import { Card, Skeleton } from "antd";
import styled from "styled-components";

const CardShimmerStyle = styled.div`
.ant-card-body {
    position: relative;
    z-index: 0;
    overflow: hidden;
    height: 100%;
    padding : 0px;
}
.ant-skeleton-element .ant-skeleton-button {
    min-width:0px;
    width:100%;
    border-radius : 3px;
    }
    .ant-skeleton-element .ant-skeleton-input {
        min-width:0px;
        width:100%;
        border-radius : 3px;
        }
        .ant-skeleton-element {
            width:100%;
        }
`;
const SmallShimmer = styled.div`

.ant-skeleton-element .ant-skeleton-button {
    min-width:0px;
    width: 20%;
    }
`;
const LargeShimmer = styled.div`

.ant-skeleton-element .ant-skeleton-button {
min-width:0px;
width: 80%;
}
`;

export default function CardShimmer() {
  return (
    <CardShimmerStyle>
      <Card
        // hoverable
        bodyStyle={{ height: "150px" }}
      >
                    <div style={{width:'100%',display:'flex'}}>
                        <div style={{flexDirection:'row',display:'flex',width:'100%'}}>
                    <div style={{width:'20%',flexDirection:'column',margin:'5px 5px 10px 5px'}}>
                    <Skeleton.Button  active={true}  style={{height:'20px'}}></Skeleton.Button>
                    </div>
                    <div style={{width:'80%',flexDirection:'column',margin:'5px 5px 10px 5px'}}>
                    <Skeleton.Input  active={true}  style={{height:'20px'}}></Skeleton.Input>
                    </div>
                    </div>

                    </div>
                    <div style={{width:'100%',display:'flex'}}>
                        <div style={{flexDirection:'row',display:'flex',width:'100%'}}>
                    <div style={{width:'70%',flexDirection:'column',margin:'0px 5px 0px 5px'}}>
                    <Skeleton.Button  active={true}  style={{height:'10px'}}></Skeleton.Button>
                    </div>
                    <div style={{width:'30%',flexDirection:'column'}}>
                    </div>
                    </div>

                    </div>
                    <div style={{width:'100%',display:'flex'}}>
                        <div style={{flexDirection:'row',display:'flex',width:'100%'}}>
                    <div style={{width:'80%',flexDirection:'column',margin:'0px 5px 0px 5px'}}>
                    <Skeleton.Button  active={true}  style={{height:'10px'}}></Skeleton.Button>
                    </div>
                    <div style={{width:'20%',flexDirection:'column'}}>
                    </div>
                    </div>

                    </div>
                    <div style={{width:'100%',display:'flex'}}>
                        <div style={{flexDirection:'row',display:'flex',width:'100%'}}>
                    <div style={{width:'80%',flexDirection:'column',margin:'0px 5px 0px 5px'}}>
                    <Skeleton.Button  active={true}  style={{height:'10px'}}></Skeleton.Button>
                    </div>
                    <div style={{width:'20%',flexDirection:'column'}}>
                    </div>
                    </div>

                    </div>
                    <div style={{width:'100%',display:'flex'}}>
                        <div style={{flexDirection:'row',display:'flex',width:'100%'}}>
                    <div style={{width:'10%',flexDirection:'column',margin:'0px 15px 0px 5px'}}>
                    <Skeleton.Avatar  active={true}  style={{height:'30px'}}></Skeleton.Avatar>
                    </div>
                    <div style={{width:'50%',flexDirection:'column',margin:'0px 5px 0px 5px'}}>
                    <Skeleton.Button  active={true}  style={{height:'30px'}}></Skeleton.Button>
                    </div>
                    <div style={{width:'40%',flexDirection:'column',margin:'0px 5px 0px 5px'}}>
                    <Skeleton.Button  active={true}  style={{height:'30px'}}></Skeleton.Button>
                    </div>
                    </div>

                    </div>

      
      </Card>
      </CardShimmerStyle>
  );
}